import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarDayViewComponent } from './calendar-day-view.component';
import { CalendarDayViewHourSegmentComponent } from './calendar-day-view-hour-segment.component';
import { CalendarDayViewEventComponent } from './calendar-day-view-event.component';
import { CalendarCommonModule } from '../common/calendar-common.module';

export {
  CalendarDayViewComponent,
  CalendarDayViewBeforeRenderEvent
} from './calendar-day-view.component';

@NgModule({
  imports: [
    CommonModule,
    CalendarCommonModule
  ],
  declarations: [
    CalendarDayViewComponent,
    CalendarDayViewHourSegmentComponent,
    CalendarDayViewEventComponent
  ],
  exports: [
    CalendarDayViewComponent,
    CalendarDayViewHourSegmentComponent,
    CalendarDayViewEventComponent
  ]
})
export class CalendarDayModule {}
